import React, { Component } from 'react';
import classNames from 'classnames';
import ParentsUtil from '../../../../library/util/ParentsUtil';

class ChildDetail extends Component {
    onClickChild = (e) => {
        e.preventDefault();

        const { childInfo, index, handleClick } = this.props;

        if (!childInfo.isSelected) {
            handleClick(index);
        }
    };

    render() {
        const {
            childInfo,
            index,
            childIndex,
            experienceProgress,
            studentPaymentContractListInfo,
        } = this.props;
        const tagName = ParentsUtil.getStudyStatus(childInfo);
        let contractYears,
            serviceDate = ParentsUtil.learningTerm(childInfo);
        if (childInfo && studentPaymentContractListInfo) {
            contractYears = ParentsUtil.getContractYears(
                childInfo,
                studentPaymentContractListInfo
            );
            if (
                contractYears === null &&
                ParentsUtil.getActorServiceStartDate(childInfo) !== ''
            ) {
                serviceDate =
                    ParentsUtil.getActorServiceStartDate(childInfo) +
                    ' ~ 무약정';
            }
        }
        return (
            <div
                className={classNames('item', { on: childIndex * 1 === index })}
                onClick={this.onClickChild}
            >
                <div className="inner">
                    <strong className="name">
                        {ParentsUtil.getActorHumanName(childInfo)}
                    </strong>
                    <span>{ParentsUtil.getActorBirthday(childInfo)}</span>
                    {ParentsUtil.isStudied(childInfo) ? (
                        <div className="tag-area">
                            <em className="tag kor">{tagName}</em>
                            {tagName !== '학습종료' && (
                                <div className="bubble-study">
                                    <strong>학습중인 과목</strong>
                                    <p>
                                        {ParentsUtil.getSubjectFullNameLabel(
                                            childInfo
                                        )}
                                    </p>
                                    <span>{serviceDate}</span>
                                </div>
                            )}
                        </div>
                    ) : experienceProgress &&
                      experienceProgress[childInfo.id] === 1 ? (
                        <p>체험 대기중</p>
                    ) : (
                        <p>학습정보가 없습니다.</p>
                    )}
                </div>
                {childInfo.isSelected && <div className="disabled-cover" />}
            </div>
        );
    }
}

export default ChildDetail;
